import { Accordion, AccordionDetails, AccordionSummary, Alert, Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { PlanPicker } from "../billing_plan_catalog/PlanPicker";
import { usePlans } from "../billing_billing_portal/useData";
import { LoadingState } from "../components";
import { Section, Seo } from "../marketing/MarketingLayout";
import { track } from "../marketing/analytics";

const FAQ = [
  ["Is there a free trial?", "Yes — 14 days on any plan, no credit card. The demo manufacturer is pre-loaded so you can explore immediately."],
  ["How are seats counted?", "Active members of your organization. Service accounts and API keys are free. Add or remove seats any time; changes are prorated."],
  ["Can I change plans later?", "Upgrade instantly. Downgrades apply at the end of the billing period; we check your sites and members fit the new plan."],
  ["Do you offer annual billing?", "Annual billing gives two months free. Enterprise contracts can be invoiced."],
  ["Where is my data stored?", "In the region you choose at signup, encrypted in transit and at rest, with daily backups. See the Security page."],
];

export function PricingPage() {
  const plans = usePlans();
  const navigate = useNavigate();
  return (
    <>
      <Seo title="Pricing" description="Simple plans for job shops to multi-site manufacturers. 14-day free trial, no credit card." />
      <Section>
        <Typography variant="h1" sx={{ fontSize: "2.4rem", textAlign: "center" }}>Plans that grow with your plant</Typography>
        <Typography color="text.secondary" textAlign="center" sx={{ mb: 4 }}>Every plan includes unlimited items, unlimited quotes and a 14-day free trial.</Typography>
        {plans.isLoading && <LoadingState />}
        {plans.isError && <Alert severity="error">Pricing is temporarily unavailable. Please try again shortly.</Alert>}
        {plans.data && <PlanPicker plans={plans.data} ctaLabel="Start free trial" onChoose={(plan, interval, addons) => { track("pricing_choose", { plan: plan.code, interval }); navigate(`/signup?plan=${plan.code}&interval=${interval}&addons=${addons.join(",")}`); }} />}
        <Box sx={{ textAlign: "center", mt: 4 }}>
          <Typography variant="body2" color="text.secondary">Need more than 10 sites, SSO/SCIM, or a custom contract?</Typography>
          <Button component="a" href="/demo?kind=enterprise" sx={{ mt: 1 }}>Talk to sales</Button>
        </Box>
      </Section>
      <Section alt>
        <Typography variant="h2" sx={{ fontSize: "1.6rem", mb: 2 }}>Frequently asked questions</Typography>
        {FAQ.map(([q, a]) => <Accordion key={q} disableGutters><AccordionSummary>{q}</AccordionSummary><AccordionDetails><Typography variant="body2" color="text.secondary">{a}</Typography></AccordionDetails></Accordion>)}
      </Section>
    </>
  );
}
